import {
  Create as SignatureIcon,
  Person as PersonIcon,
  Email as EmailIcon,
  DateRange as DateIcon,
  Schedule as ExpiryIcon,
  Phone as PhoneIcon,
  Business as CompanyIcon,
  Work as TitleIcon,
  Home as AddressIcon,
  TextFields as TextIcon,
  CheckBox as CheckboxIcon,
  Gesture as InitialsIcon
} from '@mui/icons-material';
import { FieldTypeConfig } from './types';

const fieldTypes: FieldTypeConfig[] = [
  {
    type: 'string',
    label: 'Signature',
    icon: <SignatureIcon />,
    color: '#1976d2',
    description: 'Digital signature field',
    category: 'signature',
    defaultRequired: true,
    fieldKey: 'signature'
  },
  {
    type: 'signature',
    label: 'Initials',
    icon: <InitialsIcon />,
    color: '#7b1fa2',
    description: 'Initial signature field',
    category: 'signature',
    defaultRequired: false,
    fieldKey: 'initials'
  },
  {
    type: 'string',
    label: 'Name',
    icon: <PersonIcon />,
    color: '#388e3c',
    description: 'Full name text field',
    category: 'personal',
    defaultRequired: true,
    fieldKey: 'name'
  },
  {
    type: 'string',
    label: 'Email',
    icon: <EmailIcon />,
    color: '#f57c00',
    description: 'Email address field',
    category: 'contact',
    defaultRequired: true,
    fieldKey: 'email'
  },
  {
    type: 'string',
    label: 'Phone',
    icon: <PhoneIcon />,
    color: '#0288d1',
    description: 'Phone number field',
    category: 'contact',
    defaultRequired: false,
    fieldKey: 'phone'
  },
  {
    type: 'date',
    label: 'Date',
    icon: <DateIcon />,
    color: '#d32f2f',
    description: 'Date picker field',
    category: 'dates',
    defaultRequired: false,
    fieldKey: 'date'
  },
  {
    type: 'date',
    label: 'Expiry',
    icon: <ExpiryIcon />,
    color: '#e64a19',
    description: 'Expiry date',
    category: 'dates',
    defaultRequired: true,
    fieldKey: 'expiry'
  },
  {
    type: 'string',
    label: 'Company',
    icon: <CompanyIcon />,
    color: '#5d4037',
    description: 'Company name field',
    category: 'personal',
    defaultRequired: false,
    fieldKey: 'company'
  },
  {
    type: 'string',
    label: 'Title',
    icon: <TitleIcon />,
    color: '#455a64',
    description: 'Job title field',
    category: 'personal',
    defaultRequired: false,
    fieldKey: 'title'
  },
  {
    type: 'string',
    label: 'Address',
    icon: <AddressIcon />,
    color: '#689f38',
    description: 'Address text field',
    category: 'contact',
    defaultRequired: false,
    fieldKey: 'address'
  },
  {
    type: 'string',
    label: 'Text',
    icon: <TextIcon />,
    color: '#616161',
    description: 'Custom text input field',
    category: 'other',
    defaultRequired: false,
    fieldKey: 'text'
  },
  {
    type: 'boolean',
    label: 'Checkbox',
    icon: <CheckboxIcon />,
    color: '#8bc34a',
    description: 'Checkbox for agreement',
    category: 'other',
    defaultRequired: false,
    fieldKey: 'checkbox'
  }
];

export default fieldTypes;
